import React from 'react'
import PropTypes from 'prop-types'
import CIIcon from './CIIcon'

function Carousel({ validImages, angle }) {
  return (
    <div
      className="carousels-container"
      style={{ position: 'relative', marginTop: '20px' }}
    >
      <div
        className="carousels"
        style={{
          transform: `rotateY(${angle}deg)`,
          transition: 'transform 1s',
        }}
      >
        {validImages.map((src, idx) => (
          <div
            key={idx}
            className="item"
            style={{
              transform: `rotateY(${idx * 90}deg) translateZ(95px)`,
            }}
          >
            <img
              className="carousels-customs-swiper-img"
              src={
                typeof src.file === 'string'
                  ? src.file
                  : URL.createObjectURL(src.file)
              }
              alt={src.label || 'Image'}
            />
          </div>
        ))}
      </div>
      <div
        role="presentation"
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'absolute', bottom: '-85%', right: '-35%' }}
      >
        <CIIcon />
      </div>
    </div>
  )
}

Carousel.propTypes = {
  validImages: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
        PropTypes.string,
      ]).isRequired,
      label: PropTypes.string,
    })
  ).isRequired,
  angle: PropTypes.number.isRequired,
}

export default Carousel
